import React from 'react';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {useTranslation} from 'react-i18next';

const IsolatedMenu = ({note, deleteNote, editNote}) => {
    const {t} = useTranslation();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => setAnchorEl(null);

    return (
        <div>
            <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
            >
                <MenuIcon/>
            </IconButton>

            <Menu
                id={note.id}
                MenuListProps={{
                    'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <MenuItem
                    onClick={() => {
                        deleteNote(note);
                        handleClose();
                    }}
                    style={{display: 'flex', justifyContent: 'space-around'}}
                >
                    <IconButton
                    >
                        <DeleteIcon/>
                    </IconButton>
                    {t('Delete')}
                </MenuItem>

                <MenuItem
                    onClick={() => {
                        editNote(note);
                        handleClose();
                    }}
                >
                    <IconButton>
                        <EditIcon/>
                    </IconButton>
                    {t('Edit')}
                </MenuItem>
            </Menu>
        </div>
    );
};

export default IsolatedMenu;